module.exports = __webpack_public_path__ + "static/media/ingredients-apples.300f9be7.png";